import { useCallback } from 'react';
import { ClientSubscriptionProcessingResult } from '@common/model/billing/clientSubscription';
import { ClientBillingPaymentCardCreateResponse } from '@common/model/client/billing/paymentCardCreateResponse';
import { CANCELLED_BY_USER, useModal } from 'src/shared/modalProvider';
import { CHECKOUT_MODAL } from '../lib';

export const useCheckoutModalProvider = (): ((
  tariffId: number,
) => Promise<ClientSubscriptionProcessingResult | ClientBillingPaymentCardCreateResponse>) => {
  const { openModal, closeModal } = useModal();
  return useCallback(
    (tariffId) =>
      new Promise((resolve, reject) => {
        openModal(CHECKOUT_MODAL.nss, {
          tariffId,
          onModalDestroy: () => {
            reject(CANCELLED_BY_USER);
          },
          onCancel: () => {
            closeModal(CHECKOUT_MODAL.nss);
            reject(CANCELLED_BY_USER);
          },
          onFailure: () => {
            closeModal(CHECKOUT_MODAL.nss);
            reject(CANCELLED_BY_USER);
          },
          // @ts-expect-error refactor openModal types
          onSuccess: (p: ClientSubscriptionProcessingResult | ClientBillingPaymentCardCreateResponse) => {
            resolve(p);
            closeModal(CHECKOUT_MODAL.nss);
          },
        });
      }),
    [openModal, closeModal],
  );
};
